import { ENDPOINT, HTTP } from "../config";
import { fetchFromLawfeed } from "../fetchFromLawfeed";

export const getMessages = async (chatId) => {

    

   const response = await fetchFromLawfeed({
        method: HTTP.GET,
        endpoint: ENDPOINT.MESSAGES,
        routeParams: [chatId],
    });
    return response;
}